export const videoCallActionTypes = {
  JOIN: 'videoCall/join',
  LEAVE: 'videoCall/leave',
} as const;
